// import SelectFormated;

export default class SelectFormated {
    static init(): void {
        const x = document.querySelectorAll('.select-formated');
        const l = x.length;

        for (let i = 0; i < l; i++) {
            const selElmnt = x[i].getElementsByTagName('select')[0];
            const ll = selElmnt.length;
            const a = document.createElement('DIV');
            a.setAttribute('class', 'select-selected');
            a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
            x[i].appendChild(a);
            /*for each element, create a new DIV that will contain the option list:*/
            const b = document.createElement('DIV');
            b.setAttribute('class', 'select-items select-hide');
            if (window.innerWidth >= 991) {
                b.classList.remove('select-hide');
                a.classList.add('select-arrow-active');
            }
            for (let j = 1; j < ll; j++) {
                /*for each option in the original select element,
                        create a new DIV that will act as an option item:*/
                const c = document.createElement('DIV');
                c.innerHTML = selElmnt.options[j].innerHTML;
                c.addEventListener('click', function () {
                    /*when an item is clicked, update the original select box,
                            and the selected item:*/
                    if (this.parentNode?.parentNode && this.parentNode.previousSibling) {
                        const s = this.parentNode.parentNode.querySelectorAll('select')[0];
                        const sl = s.length;
                        const h = this.parentNode.previousSibling as HTMLElement;
                        for (let i = 0; i < sl; i++) {
                            if (s.options[i].innerHTML == this.innerHTML) {
                                s.selectedIndex = i;
                                const y = this.parentNode.querySelectorAll('.same-as-selected');
                                const yl = y.length;
                                for (let k = 0; k < yl; k++) {
                                    y[k].removeAttribute('class');
                                }
                                this.setAttribute('class', 'same-as-selected');
                                //h.innerHTML = this.innerHTML;
                                break;
                            }
                        }
                    }
                });
                b.appendChild(c);
            }
            x[i].appendChild(b);
            a.addEventListener('click', function (e) {
                /*when the select box is clicked, close any other select boxes,
                        and open/close the current select box:*/
                e.stopPropagation();
                if (this.nextSibling) {
                    const sibling = this.nextSibling as HTMLElement;
                    sibling.classList.toggle('select-hide');
                }
                this.classList.toggle('select-arrow-active');
            });
        }

        // Funkce pro přidání tříd, pokud je šířka okna menší než 991px
        function addClassesForMobile() {
            document.querySelectorAll('.select-selected').forEach(function (select) {
                const element = select as HTMLElement;
                if (window.innerWidth >= 991) {
                    element.classList.remove('select-arrow-active');
                    if (element.nextElementSibling) {
                        const sibling = element.nextElementSibling as HTMLElement;
                        sibling.classList.remove('select-hide');
                    }
                } else {
                    element.classList.add('select-arrow-active');
                    if (element.nextElementSibling) {
                        const sibling = element.nextElementSibling as HTMLElement;
                        sibling.classList.add('select-hide');
                    }
                }
            });
        }

        // Zavolejte funkci při načítání stránky
        addClassesForMobile();

        // Přidání event listeneru pro resize okna, aby se dynamicky přidaly třídy při změně velikosti okna
        window.addEventListener('resize', addClassesForMobile);

    }
}
